import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from '@/common/localStorages';
import ILocalStorages from '@/common/localStorages/localStorage.types';

export const LOCAL_STORAGE_KEY = 'AK4EX';
type TLocalStorageEncryptorDataKey = typeof LOCAL_STORAGE_KEY;

export const setEncryptorStorageData = (
  value: ILocalStorages[TLocalStorageEncryptorDataKey]
) => {
  return setLocalStorage(LOCAL_STORAGE_KEY, value);
};

export const getEncryptorStorageData = ():
  | ILocalStorages[TLocalStorageEncryptorDataKey]
  | null => {
  return getLocalStorage(LOCAL_STORAGE_KEY);
};

export const removeEncryptorStorageData = () => {
  return removeLocalStorage(LOCAL_STORAGE_KEY);
};
